import Background from "../src/blurLoginBackground.jpeg";
function App() {
    return (
        <div
            style={{
                ...containerStyle,
            }}
        >
            <div
                style={{
                    ...bodyStyle,
                }}
            >
                <img
                    src={require("./NVXFullLogo2.png")}
                    style={{ height: "70px" }}
                />
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
			textAlign: "center"
                    }}
                >
                    <h1>Sitio en construcción, disculpe las molestias</h1>
                </div>
            </div>
        </div>
    );
}

export default App;

const containerStyle = {
    height: "100dvh",
    display: "flex",
    flex: 1,
    backgroundImage: `url(${Background})`,
    backgroundRepeat: "round",
    justifyContent: "center",
    alignItems: "center",
};

const bodyStyle = {
    height: "350px",
    width: "450px",
    backgroundColor: "#f1f1f1",
    borderRadius: "10px",
    display: "flex",
    border: "2px solid #00688f",
    padding: "30px",
    flexDirection: "column",
    alignItems: "center",
    gap: "5px",
    font: "roboto",
};
